import { HttpErrorResponse } from '@angular/common/http';
import { Injectable, signal } from '@angular/core';
import {Component, Inject} from '@angular/core';
import {MatDialog, MAT_DIALOG_DATA} from '@angular/material/dialog';

@Injectable({
  providedIn: 'root'
})
export class MessageService {
  messages = signal<Message[]>([]);

  constructor(public dialog: MatDialog) { }

  addMessage(message:string): void {
    this.messages.update((value) => [...value, new Message(new Date(), message)]);
  }
  
  addMessageAndNotify(type:string, message:string): void {
    this.messages.update((value) => [...value, new Message(new Date(), message)]);
    const dialogRef = this.dialog.open(AlertDialog, {
      data: {
        type:type,
        title:message
      }
    });
  }

  addMessageAndNotifyError(error: HttpErrorResponse, message:string): void {
    this.messages.update((value) => [...value, new Message(new Date(), message)]);
    const dialogRef = this.dialog.open(AlertDialog, {
      data: {
        type: 'ERROR',
        title: message,
        message: 'Server returned HTTP ' + error.status.toString() + ' (' + error.statusText + ')',
        messageDetail: JSON.stringify(error.error, null, 2)
      }
    });
  }
}

export class Message {
  timestamp:Date;
  message:string;

  constructor(timestamp:Date, msg:string) {
    this.timestamp = timestamp;
    this.message = msg;
  }
}

export interface AlertData {
  type: string,
  title: string,
  message: string,
  messageDetail: string
}

@Component({
  selector: 'dialog-content-example-dialog',
  templateUrl: 'alert-dialog.html',
  styleUrls: ['./alert-dialog.css']
})
export class AlertDialog {
  constructor(@Inject(MAT_DIALOG_DATA) public data: AlertData) {}
}